import { Flex, FlexProps } from '@chakra-ui/react';

const EditMultiInput = (props: FlexProps) => (
  <Flex
    sx={{
      bgColor: 'base2Colour.500',
      m: 0.5,
      alignItems: 'center',
      fontSize: 'sm',
      color: 'base2FontColour.500',
    }}
    {...props}
  />
);

export default EditMultiInput;
